import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import styles from '../Upload.module.scss';

interface CSVUploaderProps {
  setCsvData: (data: any) => void;
  displayName: string;
}

function CSVUploader(props: CSVUploaderProps) {
  const { setCsvData, displayName } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Function to handle file upload
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      if (!e.target) return;
      const contents = e.target.result as string;
      // Call function to parse CSV data
      parseCSV(contents);
    };

    reader.readAsText(file);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const parseCSV = (csvContent: string) => {
    const lines = csvContent.split('\n');
    const rows = lines
      .filter((line) => {
        return line.length > 0;
      })
      .map((line) => line.replace('\r', '').split(','));
    const headers: string[] = rows.shift() || [];
    const rowCount = rows.length;
    const result = [];
    for (let i = 0; i < rowCount; i++) {
      const obj = {};
      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = rows[i][j] || ''; // default to empty string if value is undefined
      }
      result.push(obj);
    }

    setCsvData(result);
  };

  return (
    <div className={styles.uploadButtonWrapper}>
      <input
        type="file"
        accept={'.csv'}
        onChange={handleFileUpload}
        style={{ display: 'none' }}
        id="csv-upload"
        ref={fileInputRef}
      />
      <label htmlFor="csv-upload">
        <div className={styles.uploadButton}>
          <FontAwesomeIcon className={styles.uploadIcon} icon="file-arrow-up" />
          {displayName}
        </div>
      </label>
    </div>
  );
}

export default CSVUploader;
